import { render, staticRenderFns } from "./greenReseed.vue?vue&type=template&id=bd95a5f4&"
import script from "./greenReseed.vue?vue&type=script&lang=js&"
export * from "./greenReseed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports